import axios from "axios";
import { ApiUrl, LoginApiUrl } from "../../../api/apiConfig";

export const registerUser = (data) => {
    return axios.post(`${LoginApiUrl}/user/register`, data);
};

export const signIn = (data) => {
    return axios.post(`${LoginApiUrl}/user/login`, data);
};

export const sendResetPwEmail = (data) => {
    return axios.post(`${ApiUrl}/send-reset-password`, data);
};

export const resetPassword = (data) => {
    return axios.put(`${LoginApiUrl}/user/resetPassword`, data);
};
